import BaseService from "./BaseService";
import {ROOT, ACCOUNT} from "./_base";

class NewsService extends BaseService {

    async getAgreeNews(params = {}) {
        const response = await this.get(`${ROOT}/${ACCOUNT}/get-agree-news`, params);
        return response.data;
    }

    async saveAgreeNews(params = {}) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/save-agree`, params);
        return response;
    }

}

export default NewsService;
